import { render } from "./MasterclassClub.vue?vue&type=template&id=57bee0b0&scoped=true"
import script from "./MasterclassClub.vue?vue&type=script&lang=js"
export * from "./MasterclassClub.vue?vue&type=script&lang=js"

import "./MasterclassClub.vue?vue&type=style&index=0&id=57bee0b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bee0b0"]])

export default __exports__